export type FollowUpReturnDestination =
  | { kind: "checklist"; label: string; scheduledQuestionnaireId: string }
  | { kind: "incident"; label: string; outOfRangeIncidentId: string }
  | {
      kind: "fireExtinguisherCheck";
      label: string;
      fireExtinguisherCheckId: string;
    }
  | {
      kind: "emergencyLightCheck";
      label: string;
      emergencyLightCheckId: string;
    }
  | { kind: "record"; label: string; eventRecordId: string }
  | { kind: "logEntry"; label: string }
  | { kind: "none" };

export type FollowUpReturnSearch = {
  scheduledQuestionnaireId?: string;
  outOfRangeIncidentId?: string;
  fireExtinguisherCheckId?: string;
  fireExtinguisherCheckItemId?: string;
  emergencyLightCheckId?: string;
  emergencyLightCheckItemId?: string;
  eventRecordId?: string;
  logEntryId?: string;
};

export function getFollowUpReturnDestination(
  search: FollowUpReturnSearch,
): FollowUpReturnDestination {
  const {
    scheduledQuestionnaireId,
    outOfRangeIncidentId,
    fireExtinguisherCheckId,
    fireExtinguisherCheckItemId,
    emergencyLightCheckId,
    emergencyLightCheckItemId,
    eventRecordId,
    logEntryId,
  } = search;

  if (emergencyLightCheckId && emergencyLightCheckItemId) {
    return {
      kind: "emergencyLightCheck",
      label: "Return to emergency lighting check",
      emergencyLightCheckId,
    };
  }

  if (fireExtinguisherCheckId && fireExtinguisherCheckItemId) {
    return {
      kind: "fireExtinguisherCheck",
      label: "Return to fire extinguisher check",
      fireExtinguisherCheckId,
    };
  }

  if (logEntryId) {
    return {
      kind: "logEntry",
      label: "Return to log history",
    };
  }

  if (outOfRangeIncidentId) {
    return {
      kind: "incident",
      label: "Return to incident",
      outOfRangeIncidentId,
    };
  }

  if (eventRecordId) {
    return {
      kind: "record",
      label: "Return to record",
      eventRecordId,
    };
  }

  if (scheduledQuestionnaireId) {
    return {
      kind: "checklist",
      label: "Return to checklist",
      scheduledQuestionnaireId,
    };
  }

  return { kind: "none" };
}
